import {Component, Inject, ChangeDetectionStrategy} from '@angular/core';
import {DialogRef, DIALOG_DATA} from '@angular/cdk/dialog';
import {WaButtonDirective, WaDialogDirective} from "angular-awesome";

interface DialogData {
  title: string;
  message: string;
  cancel_button: boolean
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [WaButtonDirective, WaDialogDirective]
})
export class ConfirmationDialogComponent {

  title: string = '';
  message: string = '';
  cancel_button: boolean = true;
  isOpen = false;

  constructor(private dialogRef: DialogRef,
              @Inject(DIALOG_DATA) data: DialogData) {

    this.title = data.title;
    this.message = data.message;
    this.cancel_button = data.cancel_button;
    this.isOpen = true;
  }

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
